const TEMPLATE_LIST_NAMES = {
    cards: "Cards",
    calendars: "Calendars",
    photogifts: "Photo gifts",
};
export const PACKAGE_LIST = {
    id: "packages",
    name: "Packages",
};
/**
 * The list a template listing reports as, such as "cards/CHRISTMAS". It uses
 * internal names, so the same list has one name in every language.
 */
export function templateList(type, category) {
    var _a;
    const typeName = (_a = TEMPLATE_LIST_NAMES[type]) !== null && _a !== void 0 ? _a : type;
    if (!category) {
        return { id: type, name: typeName };
    }
    return { id: `${type}/${category}`, name: `${typeName} / ${category}` };
}
/**
 * The packages in a package list response. Entries of type "link" point
 * somewhere else and are not items. An error response has no packages.
 */
export function viewedPackagesFromPackageList(packages) {
    return (packages !== null && packages !== void 0 ? packages : [])
        .filter((pkg) => pkg.type === "package")
        .map((pkg) => {
        var _a;
        return ({
            type: "package",
            uuid: pkg.uuid,
            name: pkg.analyticsName,
            price: listedPackagePrice(pkg),
            productNames: (_a = pkg.products) === null || _a === void 0 ? void 0 : _a.map((product) => product.name),
        });
    });
}
/** The price the package card shows - see PackageListItem's PackagePrice. */
function listedPackagePrice(pkg) {
    const originalPrice = Number(pkg.originalPrice);
    const timeLimitedPrice = Number(pkg.timeLimitedDiscountPrice);
    if (pkg.useTimeLimitedDiscount && originalPrice > timeLimitedPrice) {
        return timeLimitedPrice;
    }
    return Number(pkg.priceIncludingDiscount);
}
/** A package as /api/webshop/packages/{uuid} fills it for the subject. */
export function viewedPackage(pkg) {
    return {
        type: "package",
        uuid: pkg.uuid,
        name: pkg.name,
        price: Number(pkg.priceToPay),
        productNames: pkg.packageItems.map((item) => { var _a, _b; return (_b = (_a = item.product) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ""; }),
    };
}
export function viewedTemplateProduct(product, template, price) {
    return {
        type: "template_product",
        product: { uuid: product.uuid, name: product.name },
        template: {
            uuid: template.uuid,
            name: template.name,
            categories: template.categories,
        },
        price,
    };
}
/**
 * The price of one unit at the first price tier: the promoted price when the
 * visitor qualifies for it, otherwise the campaign price when a campaign
 * applies, otherwise the list price. Later tiers are volume prices and say
 * nothing about what the product costs.
 */
export function templateProductUnitPrice(productPrices, options) {
    if (options.promotedPrice !== null && options.promotedPrice !== undefined) {
        return Number(options.promotedPrice);
    }
    const firstTier = productPrices[0];
    if (!firstTier) {
        return 0;
    }
    if (options.campaign && firstTier.campaignprice !== null) {
        return Number(firstTier.campaignprice);
    }
    return Number(firstTier.price);
}
/** Identifies a viewed item across renders, for reporting it only once. */
export function viewedItemKey(item) {
    if (item.type === "package") {
        return `package:${item.uuid}`;
    }
    return `template_product:${item.product.uuid}:${item.template.uuid}`;
}
